<template>
  <div>
    <v-btn
        color="primary"
        text
        @click="showDialog = true"
    >
        <slot></slot>
    </v-btn>
    <v-dialog v-model="showDialog" width="500" :fullscreen="$vuetify.breakpoint.smAndDown">
        <v-toolbar
            color="primary"
            class="toolbar--wraped mb-3"
            dark
            flat
        >
            <v-toolbar-title>Account Information</v-toolbar-title>
            <v-spacer />
            <v-btn
              icon
              color="white"
              @click="showDialog = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-col>
          <flutterwave-account
            :abbreviation="$store.state.user.country_abbreviation"
            :types="types"
            :input="account"
            :removable="false"
            :editable="true"
            :showBVN="showBVN"
            :allowBranches="allowBranches"
            :allowedBankCodes="allowedBankCodes"
            @save="save"
            @loading="onLoading"
            @loaded="onLoaded"
          />
        </v-col>
    </v-dialog>
  </div>
</template>

<script>
import FlutterwaveAccount from './bank-account-templates/flutterwave-account-editable.vue';

export default {
    components: {
        'flutterwave-account': FlutterwaveAccount,
    },
    props: getProps(),
    data,
    methods: getMethods(),
};

function getProps() {
    return {
        types: Array,
        allowedBankCodes: Array,
        showBVN: {
            type: Boolean,
            default: false,
        },
        allowBranches: {
            type: Boolean,
            default: false,
        },
    };
}

function data() {
    return {
        showDialog: false,
        account: {},
    };
}

function getMethods() {
    return {
        save(payload) {
            this.showDialog = false;
            this.$emit('onFinished', {
                ...payload,
                provider: 'FLUTTERWAVE',
            });
        },
        onLoading() {
            this.$emit('loading');
        },
        onLoaded() {
            this.$emit('loaded');
        },
    };
}
</script>

<style>
  .v-dialog.v-dialog--active {
    background: #fff;
  }
</style>
